import React from 'react';
import PropTypes from 'prop-types';
import css from '../DetailsTab.scss';
import Header from '../Header';
import { getWord } from 'utils/tenant';
import ContactInformation from '../ContactInformation';
import { SFEntityID, StaffNotificationPreferences, StaffProfileData, StaffProfilePrivileges } from 'utils/types';
import ProfileSettings from './ProfileSettings';
import AboutSection from './AboutSection';
import { configHasValidHelpDeskKeys } from 'utils/profile';

/**
 * @param {object} props - see propTypes
 * @returns {node} the Profile Details tab of the staff's profile.
 */
const ProfileDetails = (props) => {

    return (
        <div className={css['header-block']}>
            <Header allowPhotoUpload={props.privileges.allowPhotoUpload}
                    firstName={props.profile.firstName}
                    hasPhoto={props.profile.hasPhoto}
                    isIE={props.isIE}
                    isStaffWithoutStudentRole={!props.privileges.hasStudentRole}
                    lastName={props.profile.lastName}
                    schoolEmail={props.profile.schoolEmail}
                    showPronouns={props.privileges.showPronouns}
                    photoAcceptTypes={props.photoAcceptTypes}
                    pronouns={props.originalProfile.pronouns}
                    userName={props.profile.userName}
                    uuid={props.profile.uuid}
                    validatePhoto={props.validatePhoto} />
            <div className={css['content-block']}>
                <ProfileSettings appointmentLinkAvailable={props.profile.appointmentLinkAvailable}
                                 homePage={props.profile.homePage}
                                 isIE={props.isIE}
                                 privileges={props.privileges}
                                 profileLinkAvailable={props.profile.profileLinkAvailable}
                                 setValue={(newUserProfile) => props.setValue({userProfile: newUserProfile})}
                                 userId={props.userId} />
                <ContactInformation allowEditPronouns={props.privileges.canEditPronouns}
                                    allowPreferredEmail={props.privileges.allowPreferredEmail}
                                    cellPhone={props.profile.cellPhone}
                                    correspondenceTo={props.profile.correspondenceTo}
                                    goToNotificationsTab={props.goToNotificationsTab}
                                    isIE={props.isIE}
                                    isStaff={true}
                                    mobileEmailInfoLink={props.mobileEmailInfoLink}
                                    phone={props.profile.phone}
                                    preferredEmail={props.profile.preferredEmail}
                                    pronouns={props.profile.pronouns}
                                    schoolEmail={props.profile.schoolEmail}
                                    // pass in setValue as is, since ContactInformation is setting the state of both userProfile and notificationPreferences
                                    setValue={props.setValue}
                                    showMobileEmailInfo={props.privileges.showMobileEmailInfo}
                                    showNotificationsLinks={true} // notifications tab always renders for staff
                                    showPronouns={props.privileges.showPronouns}
                                    staffHasStudentRole={props.privileges.hasStudentRole}
                                    supportedCountries={props.supportedCountries}
                                    textMessagingEnabled={props.privileges.textMessagingEnabled && configHasValidHelpDeskKeys(props.privileges.helpDeskInformation)}
                                    textNotificationEnabledForUser={props.notificationPreferences.textNotificationEnabled}
                                    timeZone={props.profile.timeZone}
                                    userName={props.profile.userName}
                                    videoPhone={props.profile.videoPhone} />
                {props.privileges.hasConnect &&
                    <AboutSection biography={props.profile.biography}
                                  generalOverview={props.profile.generalOverview}
                                  isIE={props.isIE}
                                  setValue={(newUserProfile) => props.setValue({userProfile: newUserProfile})}
                                  title={props.profile.title} />}
                <p className={css['footer-text']}>Some of your information is automatically populated by your institution and cannot be edited in {getWord('Starfish')}.</p>
            </div>
        </div>
    )
};

ProfileDetails.propTypes = {
    goToNotificationsTab: PropTypes.func,
    isIE: PropTypes.bool,
    mobileEmailInfoLink: PropTypes.string,
    notificationPreferences: StaffNotificationPreferences,
    originalProfile: StaffProfileData.isRequired,
    photoAcceptTypes: PropTypes.string,
    privileges: StaffProfilePrivileges,
    profile: StaffProfileData.isRequired,
    setValue: PropTypes.func.isRequired,
    supportedCountries: PropTypes.string,
    userId: SFEntityID.isRequired,
    validatePhoto: PropTypes.func.isRequired
};

export default ProfileDetails;
